import { getKitchenReferenceRules } from './get-kitchen-reference-rules';
import { ReferenceMap } from '../../shared.types';
import { RuleScope } from '../constants';

export type HasKitchenReferenceRuleParams = {
	refMap: ReferenceMap;
	rule: string;
};

export const hasKitchenReferenceRule = (params: HasKitchenReferenceRuleParams): boolean => {
	const { refMap, rule } = params;
	const rules = getKitchenReferenceRules({ ruleScope: RuleScope.Lowest, refMap });
	const allRules = [...rules.action, ...rules.validation];

	return allRules.indexOf(rule) !== -1;
};
